import { FC } from 'react';
import { Skeleton } from '@mofid-securities/uikit';
import { createSequentialArray } from '@/utils/array';

export const FundCompositionPieChartSkeleton: FC = () => {
  return (
    <div className="flex flex-1 flex-col gap-y-2 border border-transparent p-4">
      <Skeleton height={18} width={96} />
      <div className="flex items-center">
        <div className="flex flex-grow flex-col gap-y-3.5">
          {createSequentialArray(4).map((n) => (
            <div key={n} className="flex gap-x-2">
              <Skeleton height={18} width={18} />
              <Skeleton height={18} width={112} />
            </div>
          ))}
        </div>
        <div className="relative flex h-[124px] w-[124px]">
          <Skeleton
            className="absolute left-0 top-0"
            height={124}
            width={124}
            isCircle
          />
          <div className="absolute left-[24px] top-[24px] h-[76px] w-[76px] rounded-full bg-white" />
        </div>
      </div>
    </div>
  );
};
